import {
  getToken, setToken, getRefreshToken, setRefreshToken,
  getTokenTime, setTokenTime, clearAuth
} from '@/utils/storage'
import { login as loginApi, refreshToken as refreshTokenApi, logout as logoutApi } from '@/api/endpoints'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    token: getToken(),
    refreshToken: getRefreshToken(),
    tokenTime: getTokenTime()
  },
  getters: {
    isAuthenticated: state => !!state.token
  },
  mutations: {
    SET_TOKEN(state, { accessToken, refreshToken, tokenTime }) {
      state.token = accessToken
      state.refreshToken = refreshToken
      state.tokenTime = tokenTime
      setToken(accessToken)
      setRefreshToken(refreshToken)
      setTokenTime(tokenTime)
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.refreshToken = null
      state.tokenTime = null
      clearAuth()
    }
  },
  actions: {
    async login({ commit }, credentials) {
      const data = await loginApi(credentials)
      commit('SET_TOKEN', {
        accessToken: data.access_token,
        refreshToken: data.refresh_token,
        tokenTime: new Date().getTime()
      })
    },
    async refreshToken({ commit, state, dispatch }) {
      if (!state.refreshToken) return
      try {
        const data = await refreshTokenApi(state.refreshToken)
        if (data) {
          commit('SET_TOKEN', {
            accessToken: data.access_token,
            refreshToken: data.refresh_token,
            tokenTime: new Date().getTime()
          })
        }
      } catch (e) {
        dispatch('logout')
      }
    },
    logout({ commit, dispatch }) {
      logoutApi().catch(() => {})
      commit('CLEAR_AUTH')
      dispatch('timer/stopTimers', null, { root: true })
      // Clear cached user data so next login fetches fresh data
      this.commit('user/CLEAR_ME')
      // Centralized redirect — the single source of logout navigation
      router.replace('/login').catch(() => {})
    }
  }
}
